import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface ProposalListItem_V2Props {
  title: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
}
export default function ProposalListItem_V2({ title, subtitle }: ProposalListItem_V2Props) {
  return (
    <div data-meta="ProposalListItem_V2" className="backdrop-blur-sm bg-white/30 rounded-3xl p-6">
      <div className=" flex flex-col justify-between sm:grid sm:grid-cols-12 gap-x-4 text-white">
        <CustomRichText
          data={title}
          tag="div"
          className="text-md md:text-xl sm:col-span-6 font-bold py-2"
        />
        <CustomRichText data={subtitle} tag="div" className="col-span-6" />
      </div>
    </div>
  );
}
